import script from "./UIButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./UIButton.vue?vue&type=script&setup=true&lang=ts"

import "./UIButton.vue?vue&type=style&index=0&id=6f9ff9a2&lang=css"

const __exports__ = script;

export default __exports__